import { Component, Prop, h, Host, State } from '@stencil/core';
import { alert_exclamation_circle } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-marketweb-input',
  styleUrl: 'pn-marketweb-input.scss',
})
export class PnMarketwebInput {
  @Prop() disabled: boolean = false;
  /** Error message; will take precedence over helpertext if both are provided (applies invalid styles automatically) */
  @Prop() error: string = '';
  /** Error state without message (If you want to control the error messaging on your own) */
  @Prop() invalid: boolean = false;
  /** Text message placed underneath the input field */
  @Prop() helpertext: string = '';
  /** Text label placed above the input field */
  @Prop() label: string = '';
  @Prop() placeholder: string = '';
  @Prop() inputid: string = `${Math.random()}`;
  @Prop() name: string = '';
  @Prop() required: boolean = false;
  @Prop({ mutable: true }) type: string = 'text';
  @Prop() autocomplete: string = '';
  @Prop() valid: boolean = null;
  @Prop() value: string = '';
  /** The maximum number of characters the user should be able to add, also adds a visible counter */
  @Prop() maxlength: string = '';
  @Prop() min: string = '';
  @Prop() max: string = '';
  @Prop() step: string = '';
  @Prop() pattern: string = '';

  getTextMessage() {
    if (this.error) return this.error;
    if (this.helpertext) return this.helpertext;

    return null;
  }

  @State() showText: boolean = false;
  toggleTextVisibility() {
    this.showText = !this.showText;
  }

  getInputType() {
    let types = ['text', 'password', 'url', 'tel', 'search', 'number', 'email', 'date', 'datetime-local', 'month', 'week', 'time'];

    return types.includes(this.type) && !this.showText ? this.type : 'text';
  }

  setVal(e) {
    const target: HTMLInputElement = e.composedPath?.()[0] as HTMLInputElement;
    this.value = target.value;
  }

  getClassNames() {
    let classNames = 'pn-input ';
    if (this.error.length > 0 || this.invalid) classNames += 'error ';
    if (this.valid) classNames += 'valid ';
    if (this.type === 'password') classNames += 'password ';
    if (this.error || this.invalid || this.valid) classNames += 'icon ';

    return classNames;
  }

  render() {
    return (
      <Host class={this.getClassNames()}>
        {(this.label || this.maxlength) && (
          <div class="label-container">
            {this.label && <label htmlFor={this.inputid}>{this.label}</label>}
            {parseInt(this.maxlength) > 0 && (
              <label class="char-count" htmlFor={this.inputid}>
                {`${this.value.length}/${this.maxlength}`}
              </label>
            )}
          </div>
        )}
        <div class="input-container">
          <input
            type={this.getInputType()}
            value={this.value}
            id={this.inputid}
            name={this.name}
            placeholder={this.placeholder}
            disabled={this.disabled}
            required={this.required}
            autocomplete={this.autocomplete}
            onInput={e => this.setVal(e)}
            maxlength={this.maxlength ? this.maxlength : null}
            min={this.min ? this.min : null}
            max={this.max ? this.max : null}
            step={this.step ? this.step : null}
            pattern={this.pattern ? this.pattern : null}
          />
          <svg class="pn-input-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <polyline class="checkmark-path" points="4,12 9,17 20,6" stroke-width="3" />
          </svg>

          {this.type === 'password' && !this.disabled && <button onClick={() => this.toggleTextVisibility()}>Show</button>}
        </div>

        {this.getTextMessage() && (
          <small>
            {this.error && <pn-icon icon={alert_exclamation_circle} small color="warning"></pn-icon>}
            {this.getTextMessage()}
          </small>
        )}
      </Host>
    );
  }
}
